import React from "react";
import "./MyStory.css";

const MyStory = () => {
  return (
    <div className="my-story-container">
      <div className="my-story-content">
        <h2 className="my-story-title">About Fleurè</h2>
        <p className="my-story-text">
          <strong>Fleurè</strong> was created to introduce something the UK has
          not seen before.
        </p>
        <p className="my-story-text">
          Inspired by international travel and the café cultures of cities
          around the world, Fleure brings together artisanal floristry and
          specialty coffee in one immersive destination. Every detail is
          intentional — designed to make you feel transported, as though you’ve
          stepped into another place entirely.
        </p>
        <p className="my-story-text">
          This is not simply a café. Not simply a florist. Fleure is an
          experience shaped by atmosphere, craftsmanship, and global influence.
          A space where flowers, coffee, and design come together to elevate
          everyday moments.
        </p>
        <p className="my-story-text">
          Built with a vision beyond borders, Fleure is the UK’s first café &
          florist concept — created to stand alongside the world’s most iconic
          lifestyle brands, with global expansion in mind.
        </p>
      </div>
    </div>
  );
};

export default MyStory;
